import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import DatePicker from "react-datepicker";
import ReCAPTCHA from "react-google-recaptcha";
import SectionSeparator from "../SectionSeparator";
import SubSectionSeparator from "../SubSectionSeparator";
import AdmissionCountries from "../AdmissionCountries";
import FilePicker from "../FilePicker";
import moment from "moment";

const StudentDetailsStep = ({ ctx }) => {
  const {
    ageGroup,
    countries,
    errors,
    formData,
    handleChange,
    picture,
    recaptcha,
    setFormData,
    setPicture,
  } = ctx;
  return (
    <>
      <Row className="justify-content-end">
        <Col md={2}>
          <FilePicker
            name="picture"
            file={picture}
            setFile={setPicture}
            height={200}
            error={errors?.picture}
          />
        </Col>
        <Col md={2} className="d-flex align-items-center">
          <FormattedMessage id="child_picture" />
        </Col>
        <Col
          md={12}
          xl={8}
          className="ml-lg-auto d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-end gap-5 flex-column-reverse mt-5 lg:mt-3"
        >
          {/* <CenterDropdown
                      onSelectCenter={handleCenterSelect}
                      isEditMode={formData?.admission_id ? true : false}
                      selectedCenterId={formData?.center_id}
                      centers={centers}
                      error={errors?.center_id}
                     /> */}

          <ReCAPTCHA
            ref={recaptcha}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          />
        </Col>
      </Row>

      {/* Child Details */}
      <SectionSeparator title="title.child_details" />
      <Row>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="child_name">
              {(placeholder) => (
                <Form.Control
                  value={formData.child_name}
                  placeholder={placeholder}
                  type="text"
                  name="child_name"
                  onChange={handleChange}
                  isInvalid={!!errors.child_name}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.child_name" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="child_middle_name">
              {(placeholder) => (
                <Form.Control
                  value={formData.child_middle_name}
                  placeholder={placeholder}
                  type="text"
                  name="child_middle_name"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="child_family_name">
              {(placeholder) => (
                <Form.Control
                  value={formData.child_family_name}
                  placeholder={placeholder}
                  type="text"
                  name="child_family_name"
                  onChange={handleChange}
                  isInvalid={!!errors.child_family_name}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.child_name" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="birth_date">
              {(placeholder) => (
                <DatePicker
                  placeholderText={placeholder}
                  className={
                    errors.birth_date
                      ? " form-control is-invalid"
                      : "form-control"
                  }
                  selected={
                    formData.birth_date ? new Date(formData.birth_date) : null
                  }
                  onChange={(date) => {
                    if (date) {
                      const formattedDate = moment(date).format("YYYY-MM-DD");
                      setFormData((prev) => ({
                        ...prev,
                        birth_date: formattedDate,
                      }));
                    } else {
                      setFormData((prev) => ({
                        ...prev,
                        birth_date: null,
                      }));
                    }
                  }}
                  dateFormat="dd/MM/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  isClearable
                />
              )}
            </FormattedMessage>
            <div className={errors.birth_date ? "is-invalid" : ""}></div>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.birth_date" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <Form.Select
              name="gender"
              onChange={handleChange}
              value={formData.gender}
              isInvalid={!!errors.gender}
            >
              <option value="">
                <FormattedMessage id="select_gender" />
              </option>
              <option value="F">
                <FormattedMessage id="female" />
              </option>
              <option value="M">
                <FormattedMessage id="male" />
              </option>
            </Form.Select>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.gender" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <Form.Select
              onChange={handleChange}
              name="country_id"
              value={formData.country_id}
              isInvalid={!!errors.country_id}
            >
              <option value="">
                <FormattedMessage id="select_nationality" />
              </option>
              {countries.map((country, index) => (
                <option key={index} value={country.country_id}>
                  {country.name_en}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.country_id" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <Form.Select
              onChange={handleChange}
              name="religion"
              value={formData.religion}
              isInvalid={!!errors.religion}
            >
              <option value="">
                <FormattedMessage id="select_religion" />
              </option>
              <option value="1">
                <FormattedMessage id="other" />
              </option>
              <option value="2">
                <FormattedMessage id="muslim" />
              </option>
              <option value="3">
                <FormattedMessage id="christian" />
              </option>
            </Form.Select>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.religion" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="id_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.id_number}
                  placeholder={placeholder}
                  type="text"
                  name="id_number"
                  onChange={handleChange}
                  maxLength={10}
                  isInvalid={!!errors.id_number}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.id_number" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <Form.Select
              name="agegroup_id"
              onChange={handleChange}
              value={formData.agegroup_id}
              isInvalid={!!errors.agegroup_id}
            >
              <option value="">
                <FormattedMessage id="agegroup_id" />
              </option>
              {ageGroup?.map((language, index) => (
                <option key={index} value={language.agegroup_id}>
                  {language.agegroup_code}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.agegroup_id" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group className="mb-4">
            <FormattedMessage id="home_address">
              {(placeholder) => (
                <Form.Control
                  value={formData.home_address}
                  placeholder={placeholder}
                  as="textarea"
                  rows={3}
                  name="home_address"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
      </Row>

      {/* Family Details */}
      <SectionSeparator title="title.family_details" />
      <SubSectionSeparator title="title.sponsor_parent_information" />
      <Row>
        {/* <Col md={3}>
                    <Form.Group className="mb-4">
                      <ToggleButtonGroup
                        type="radio"
                        name="sponsor_role"
                        value={formData.sponsor_role}
                        onChange={(val) =>
                          setFormData({ ...formData, sponsor_role: val })
                        }
                        isInvalid={!!errors.sponsor_role}
                        className="w-100"
                      >
                        <ToggleButton
                          id="sponsor-father-toggle"
                          value="Father"
                          variant="outline-primary"
                          className="first-btn"
                        >
                          <FormattedMessage
                            id="father"
                            defaultMessage="Father"
                          />
                        </ToggleButton>
                        <ToggleButton
                          id="sponsor-mother-toggle"
                          value="Mother"
                          variant="outline-primary"
                          className="second-btn"
                        >
                          <FormattedMessage
                            id="mother"
                            defaultMessage="Mother"
                          />
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Form.Group>
                   </Col> */}

        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="full_name">
              {(placeholder) => (
                <Form.Control
                  value={formData.father_name}
                  placeholder={placeholder}
                  type="text"
                  name="father_name"
                  onChange={handleChange}
                  isInvalid={!!errors.father_name}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.full_name" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="mobile_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.father_mobile}
                  placeholder={placeholder}
                  type="text"
                  name="father_mobile"
                  onChange={handleChange}
                  isInvalid={!!errors.father_mobile}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.mobile" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="work_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.father_workphone}
                  placeholder={placeholder}
                  type="text"
                  name="father_workphone"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="email_address">
              {(placeholder) => (
                <Form.Control
                  value={formData.father_email}
                  placeholder={placeholder}
                  type="text"
                  name="father_email"
                  onChange={handleChange}
                  isInvalid={!!errors.father_email}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.email" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="place_of_work">
              {(placeholder) => (
                <Form.Control
                  value={formData.father_employer}
                  placeholder={placeholder}
                  type="text"
                  name="father_employer"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="occupation">
              {(placeholder) => (
                <Form.Control
                  value={formData.father_position}
                  placeholder={placeholder}
                  type="text"
                  name="father_position"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <Form.Select
              onChange={handleChange}
              name="father_nationality"
              value={formData.father_nationality}
              isInvalid={!!errors.father_nationality}
            >
              <option value="">
                <FormattedMessage id="select_nationality" />
              </option>
              {countries.map((country, index) => (
                <option key={index} value={country.country_id}>
                  {country.name_en}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.father_nationality" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="id_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.father_id_number}
                  placeholder={placeholder}
                  type="text"
                  name="father_id_number"
                  required
                  onChange={handleChange}
                  maxLength={10}
                  isInvalid={!!errors.father_id_number}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.id_number" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        {/* <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="home_address">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.home_address}
                            placeholder={placeholder}
                            type="text"
                            name="home_address"
                            onChange={handleChange}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                   </Col> */}
      </Row>

      <SubSectionSeparator title="title.spouse_information" />
      <Row>
        {/* <Col md={3}>
                    <Form.Group className="mb-4">
                      <ToggleButtonGroup
                        type="radio"
                        name="spouse_role"
                        value={formData.spouse_role}
                        onChange={(val) =>
                          setFormData({ ...formData, spouse_role: val })
                        }
                        isInvalid={!!errors.spouse_role}
                        className="w-100"
                      >
                        <ToggleButton
                          id="spouse-father-toggle"
                          value="Father"
                          variant="outline-primary"
                          className="first-btn"
                        >
                          <FormattedMessage
                            id="father"
                            defaultMessage="Father"
                          />
                        </ToggleButton>
                        <ToggleButton
                          id="spouse-mother-toggle"
                          value="Mother"
                          variant="outline-primary"
                          className="second-btn"
                        >
                          <FormattedMessage
                            id="mother"
                            defaultMessage="Mother"
                          />
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Form.Group>
                   </Col> */}
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="full_name">
              {(placeholder) => (
                <Form.Control
                  value={formData.mother_name}
                  placeholder={placeholder}
                  type="text"
                  name="mother_name"
                  onChange={handleChange}
                  isInvalid={!!errors.mother_name}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.full_name" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="mobile_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.mother_mobile}
                  placeholder={placeholder}
                  type="text"
                  name="mother_mobile"
                  onChange={handleChange}
                  isInvalid={!!errors.mother_mobile}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.mobile" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="work_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.mother_workphone}
                  placeholder={placeholder}
                  type="text"
                  name="mother_workphone"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="email_address">
              {(placeholder) => (
                <Form.Control
                  value={formData.mother_email}
                  placeholder={placeholder}
                  type="text"
                  name="mother_email"
                  onChange={handleChange}
                  isInvalid={!!errors.mother_email}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.email" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="place_of_work">
              {(placeholder) => (
                <Form.Control
                  value={formData.mother_employer}
                  placeholder={placeholder}
                  type="text"
                  name="mother_employer"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="occupation">
              {(placeholder) => (
                <Form.Control
                  value={formData.mother_position}
                  placeholder={placeholder}
                  type="text"
                  name="mother_position"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <Form.Select
              onChange={handleChange}
              name="mother_nationality"
              value={formData.mother_nationality}
              isInvalid={!!errors.mother_nationality}
            >
              <option value="">
                <FormattedMessage id="select_nationality" />
              </option>
              {countries.map((country, index) => (
                <option key={index} value={country.country_id}>
                  {country.name_en}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.mother_nationality" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <SubSectionSeparator title="title.sibling_information" />
      <Row>
        <Col md={4}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="sibling_name">
              {(placeholder) => (
                <Form.Control
                  value={formData.child_siblings}
                  placeholder={placeholder}
                  type="text"
                  name="child_siblings"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-4">
            <FormattedMessage id="sibling_age">
              {(placeholder) => (
                <Form.Control
                  value={formData.child_siblings_age}
                  placeholder={placeholder}
                  type="text"
                  name="child_siblings_age"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-4">
            <FormattedMessage id="school_attending">
              {(placeholder) => (
                <Form.Control
                  value={formData.child_school_attending}
                  placeholder={placeholder}
                  type="text"
                  name="child_school_attending"
                  onChange={handleChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
      </Row>

      <SectionSeparator title="title.emergency_contact" />
      <Row>
        <Col md={4}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="name">
              {(placeholder) => (
                <Form.Control
                  value={formData.emergency_contact1}
                  placeholder={placeholder}
                  type="text"
                  name="emergency_contact1"
                  onChange={handleChange}
                  isInvalid={!!errors.emergency_contact1}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.emergency_contact_name" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="relation">
              {(placeholder) => (
                <Form.Control
                  value={formData.emergency_relation1}
                  placeholder={placeholder}
                  type="text"
                  name="emergency_relation1"
                  onChange={handleChange}
                  isInvalid={!!errors.emergency_relation1}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.emergency_contact_relation" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="contact_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.emergency_phone1}
                  placeholder={placeholder}
                  type="text"
                  name="emergency_phone1"
                  onChange={handleChange}
                  isInvalid={!!errors.emergency_phone1}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.emergency_contact_number" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <SectionSeparator title="title.admission_countries" />

      <AdmissionCountries
        admissioncountries={formData.admissioncountries}
        errors={errors}
        setFormData={setFormData}
      />
    </>
  );
};

export default StudentDetailsStep;
